<div class="main">
  <div *ngIf="expand" class="sidebar">
    <app-sidebar></app-sidebar>
  </div>
  <div class="main-container" [ngClass]="{'full-width': !expand}">
    <app-header (toggleMenu)="toggleMenu($event)"></app-header>
    <div class="content-container">
      <div class="content" style="text-align: justify">
        <router-outlet></router-outlet>
      </div>
    </div>
    <app-footer [expand]="expand"></app-footer>
  </div>
</div>
